import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser, openBlob } from 'src/utils/Common';
import { loadUrunControlDetail } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles(theme => ({
  divider: {
    backgroundColor: '#1D3343'
  }
}));

function HelperControl({ className, FisNo, tasks, readonly, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('product_detail_control');
  const [YardimciDataControl, setYardimciDataControl] = useState([]);
  const [YardimciDataLibraryControl, setYardimciDataLibraryControl] = useState(
    []
  );
  const [
    YardimciDataLibraryDetailControl,
    setYardimciDataLibraryDetailControl
  ] = useState([]);
  const [LoadingControl, setLoadingControl] = useState(true);
  const [expandedControl, setExpandedControl] = useState(false);
  const [openControl, setOpenControl] = React.useState(false);
  const [UyariControl, setUyariControl] = React.useState('');

  const SessionUser = getUser();
  const YardimciDataDegerControl = loadUrunControlDetail();

  const KulModelKodu =
    YardimciDataDegerControl.length > 0
      ? YardimciDataDegerControl[0].KUL_MODEL_KODU
      : '';
  useEffect(() => {
    let mounted = true;
    const fetchLogs = () => {
      axios
        .get(`/GetArtemisTechnicianHelper/${KulModelKodu || '-1'}`)
        .then(response => {
          if (mounted) {
            const Deger = response.data === '' ? [] : response.data;
            setYardimciDataControl(Deger);
          }
        })
        .catch(error => {
          setLoadingControl(false);
        });
      axios
        .get(`/GetArtemisLibrary/${KulModelKodu}`)
        .then(response => {
          if (mounted) {
            const DegerLibraryControl =
              response.data === '' ? [] : response.data;
            setYardimciDataLibraryControl(DegerLibraryControl);
            setLoadingControl(false);
          }
        })
        .catch(error => {
          setLoadingControl(false);
        });
    };
    fetchLogs();
    return () => {
      mounted = false;
    };
  }, [KulModelKodu]);

  const GetLibraryDetailControl = panel => {
    setLoadingControl(true);
    axios
      .get(`/GetArtemisDetailLibrary/${KulModelKodu}/${panel}`)
      .then(response => {
        const Deger = response.data === '' ? [] : response.data;
        setYardimciDataLibraryDetailControl(Deger);
        setLoadingControl(false);
      })
      .catch(error => {
        setLoadingControl(false);
      });
  };

  const DetayAcControl = log => {
    setLoadingControl(true);
    const data = {
      ServiceShopId: SessionUser.ServiceShopId,
      UserId: SessionUser.UserId,
      FilePtr: log.FP
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusBulletin', data, config)
      .then(response => {
        openBlob(response.data, `${log.BK}_${log.BN}`);
        setLoadingControl(false);
      })
      .catch(error => {
        setUyariControl(t('Bulten_error'));
        setOpenControl(true);
        setLoadingControl(false);
      });
  };

  const handleChangeControl = panel => (event, isExpanded) => {
    setExpandedControl(isExpanded ? panel : false);
    if (isExpanded === true) {
      GetLibraryDetailControl(panel);
    }
  };

  const handleOpenTHelperControl = (event, Link) => {
    event.persist();
    window.open(Link);
    event.persist();
  };

  const user = getUser();
  const user_types = user.TechnicianType.split(',');
  let klima_teknisyeni = false;
  user_types &&
    user_types.forEach(u => {
      if (parseInt(u.TIP) === 26) {
        klima_teknisyeni = true;
      }
    });
  if (klima_teknisyeni) {
    return (
      <Card>
        <CardHeader title={t('Yetki_Kontrolu')} />
        <Divider />
        <CardContent className={classes.contentMin}>
          {t('Yetki_Mesaji')}
        </CardContent>
      </Card>
    );
  }

  const handleCloseControl = () => {
    setOpenControl(false);
  };

  return (
    <div>
      <Dialog
        open={openControl}
        onClose={handleCloseControl}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {UyariControl}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseControl} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      {window.navigator.onLine ? (
        <div className={clsx(classes.root, className)}>
          <Card>
            <CardHeader title={t('Urun_Kutuphanesi')} />
            <Divider />
            {LoadingControl ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            ) : (
              <div />
            )}
            <CardContent className={classes.content}>
              <List className={classes.root}>
                {YardimciDataControl.map(log => (
                  <div key={log.ACIKLAMA}>
                    <ListItem
                      alignItems="flex-start"
                      onClick={event =>
                        handleOpenTHelperControl(event, log.LINK)}
                    >
                      <ListItemAvatar>
                        <div>
                          <Typography
                            component="span"
                            variant="h6"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {log.HIZMET_ACIKLAMA}
                          </Typography>
                        </div>
                      </ListItemAvatar>
                      <ListItemText primary={log.ACIKLAMA} />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </div>
                ))}
              </List>
            </CardContent>
          </Card>
          <Divider className={classes.divider} />
          <Card className={classes.contentMin}>
            <CardHeader title={t('Kutuphane')} />
            {YardimciDataLibraryControl.map(log => (
              <ExpansionPanel
                key={log.ACIKLAMA}
                expanded={expandedControl === log.BANKATIPI}
                onChange={handleChangeControl(log.BANKATIPI)}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography className={classes.heading}>
                    {log.ADET} + ' ' +
{t('lblAdet')}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {log.ACIKLAMA}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <TableContainer component={Paper}>
                    {/* {
                      Loading ?
                        <CircularProgress
                          status={'loading'}
                          style={{ marginLeft: '50%' }}
                        />
                        : <div></div>
                    } */}
                    <Table className={classes.table} aria-label="simple table">
                      <TableBody>
                        {YardimciDataLibraryDetailControl.map(row => (
                          <TableRow key={row.A}>
                            <TableCell
                              component="th"
                              onClick={e => DetayAcControl(row)}
                              scope="row"
                            >
                              {row.A}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            ))}
          </Card>
        </div>
      ) : (
        <Card className={clsx(classes.root, className)}>
          <CardHeader title={t('Teknisyen_Yardimcisi')} />
          <CardContent className={classes.contentMin}>
            {t('Offline_message')}
          </CardContent>
        </Card>
      )}
    </div>
  );
}

HelperControl.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }))(HelperControl);
